import React, { useContext } from "react";

// context
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// components
import CustomDialog from "../common/customDialog";
import PopupHeader from "../common/popupHeader";
import CenterMngtPop from "bodycodi/cmap/app/components/cmap5010/centerMngtPop";
import CenterProfilePop from "bodycodi/cmap/app/components/cmap5010/centerProfilePop";

// assets
import RightIcon from "bodycodi/cmap/app/svg/icon_right_gray_18.svg";
import MainCenterActive from "bodycodi/cmap/app/img/icon-main-center-active.png";
import MainCenterDisable from "bodycodi/cmap/app/img/icon-main-center-disable.png";

// utils
import { isEmpty } from "../../js/common";

const CenterMngtIndexPop = ({ CoachVO, update }: any) => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CENTER_MNGT_INDEX_POP",
      open: { centerMngtIndexPop: false },
    });
  };

  const openCenterMngtPop = () => {
    if (isEmpty(CoachVO)) return null;
    dispatch({ type: "POP_UP_OPEN", id: "CENTER_MNGT_POP", open: { centerMngtPop: true } });
  };

  const openCenterProfilePop = () => {
    if (isEmpty(CoachVO)) return null;
    dispatch({ type: "POP_UP_OPEN", id: "CENTER_PROFILE_POP", open: { centerPropfilePop: true } });
  };

  return (
    <CustomDialog open={state.centerMngtIndexPop} onClose={handleClose}>
      <PopupHeader title="센터 관리" onClickBack={handleClose} />
      <div className="popup-body no-padding">
        <div className={"my-page-center-list"}>
          <div className="my-page-center">
            {!isEmpty(CoachVO) && <img src={MainCenterActive} />}
            {isEmpty(CoachVO) && <img src={MainCenterDisable} />}
            <span className="center-name">
              {isEmpty(CoachVO) && "아직 연동된 센터가 없어요."}
              {!isEmpty(CoachVO) && CoachVO.partnerName}
            </span>
          </div>
          <div className="my-page-center-btn">
            <span className="title" onClick={openCenterMngtPop}>
              연동센터 설정 관리
            </span>
            <img src={RightIcon} />
          </div>
          <div className="my-page-center-btn" onClick={openCenterProfilePop}>
            <span className="title">센터별 프로필 설정</span>
            <img src={RightIcon} />
          </div>
        </div>
      </div>
      <CenterMngtPop />
      <CenterProfilePop update={update} />
    </CustomDialog>
  );
};

export default CenterMngtIndexPop;
